import * as Actions from 'actions';
import * as ActionTypes from 'constants';
import { takeEvery, takeLatest } from 'redux-saga';
import { call, put, select } from 'redux-saga/effects';
import { socket } from '../utils/sockets';

import * as Api from 'api';

/***************************** Selectors ************************************/

export const getClient = state => (state.client);

/***************************** Subroutines ************************************/

function* fetchClient(action) {
  try {
    const client = yield call(Api.fetchClient, action.payload.id);
    yield put(Actions.receiveClient(client));
    yield put(Actions.addClientToUser(client));
  } catch (ex) {
    yield call(putError, action, ex);
  }
}

function * fetchClientFailed(action) {
	try {
		yield put(Actions.notify({message : action.payload.message || action.payload}))
		yield put(Actions.toggleInitFlag(false))
	}
	catch(ex) {
		console.log('ERROR : ', ex.message || ex)
	}
}

function* newInteractionSuccess(action) {
  try {
    yield put(Actions.newClientInteraction(action.payload.interaction));
  } catch (ex) {
    yield call(putError, action, ex);
  }
}

function* newClientTaskSuccess(action) {
  try {
    yield put(Actions.newClientTask(action.payload.task));
  } catch (ex) {
    yield call(putError, action, ex);
  }
}

function* updateClientTask(action) {
  try {

  } catch (ex) {
    yield call(putError, action, ex);
  }
}

function* clientAssignedToUser(action) {
  try {

  } catch (ex) {
    yield call(putError, action, ex);
  }
}

function * clientUpdateSuccess( action ) {
  try {
    const client = yield call(Api.fetchClient, action.payload.client);
    yield put(Actions.receiveClient(client));
    yield put(Actions.notify({
      title : 'Success!',
      message : 'Client Updated.',
    }, {
      type : 'success'
    }))
  } catch (ex) {
    yield call(putError, action, ex);
  }
}

function * clientUpdateFailed( action ) {
  yield put(Actions.toggleFetchingClient(false));
  yield put(Actions.notify({
    title : 'Error Updating Client',
    message : action.payload.message
  }));
}

function* clientAssignFailed(action) {
  try {
    yield put(Actions.notify({
      title: 'Error Assigning Client',
      message: action.payload.message,
    }))
  } catch (ex) {
    yield call(putError, action, ex);
  }
}

function* clientAssignSuccess(action) {
  try {
    yield fetchClient({ payload: { id: action.payload.client } });
    let jobs = yield call(Api.getJobsByClient, action.payload.client)
    let client = yield select(getClient)
    for(let i = 0; i < jobs.length; i++) {
    	yield call(Api.updateJob, {_id : jobs[i]._id, assigned_to : client.owner._id})
    }
  } catch (ex) {
    yield call(putError, action, ex);
  }
}

function *deleteClient(action) {
  const { client } = action.payload;
  try {
    yield put(Actions.sendSocketEmit({client : client._id || client}, 'delete-client'));
    yield put(Actions.push('/clients'));
  }
  catch(ex) {
    yield put({ type: 'DELETE_CLIENT_FAILED', payload: {...ex}})
  }
}

function *deleteClientFailed(action) {
  yield put(Actions.notify(action.payload));
}

function * taskCreationFailed(action) {
  yield put(Actions.notify(action.payload));
}
  /******************************************************************************/
  /******************************* WATCHERS *************************************/
  /******************************************************************************/

export function* clientFetchWatcher() {
  yield * takeEvery(ActionTypes.FETCH_CLIENT, fetchClient);
}

export function* newInteractionWatcher() {
  yield * takeEvery(ActionTypes.CLIENT_INTERACTION_NEW_SUCCESS, newInteractionSuccess);
}

export function* newTaskWatcher() {
  yield * takeEvery(ActionTypes.CLIENT_TASK_NEW_SUCCESS, newClientTaskSuccess);
}

export function* updateTaskWatcher() {
  yield * takeEvery(ActionTypes.CLIENT_TASK_UPDATE_SUCCESS, updateClientTask);
}

export function * clientAssignWatcher() {
  yield [
    takeEvery(ActionTypes.DELETE_CLIENT, deleteClient),
    takeEvery(ActionTypes.DELETE_CLIENT_FAILED, deleteClientFailed),
    takeEvery(ActionTypes.CLIENT_UPDATE_SUCCESS, clientUpdateSuccess),
    takeEvery(ActionTypes.CLIENT_UPDATE_FAILED, clientUpdateFailed),
    takeEvery(ActionTypes.CLIENT_ASSIGN_FAILED, clientAssignFailed),
    takeEvery(ActionTypes.CLIENT_ASSIGN_SUCCESS, clientAssignSuccess),
    takeEvery(ActionTypes.FETCH_CLIENT_FAILED, fetchClientFailed),
    takeEvery(ActionTypes.TASK_NEW_FAILED, taskCreationFailed),
  ]
}
/***************************** Helpers ************************************/

function* putError(action, ex) {
  console.log('Putting Error: ', action, ex);
  yield put(Actions.notify(ex))
  yield put({ type: `${action.type}_FAILED`, payload: ex });
}



// WEBPACK FOOTER //
// ./src/common/sagas/client.js